import { type apiClientErrorType } from './api-client'
import { type AddNotificationType } from '@/store/notifications'
import { type Router } from 'vue-router'

interface ErrorResponseType {
  type: string
  status: number
  title: string
  detail: string
  errors?: Record<string, string[]>
  // TODO: Include string from errors object if present in message
}

const ERROR_NOTIFY_DEBOUNCE_MS = 2000
const GENERIC_SERVER_ERROR_MESSAGE =
  'Something went wrong on our end. Please try again shortly.'
const GENERIC_NETWORK_ERROR_MESSAGE = 'Network Error'
let lastErrorNotify: { message: string; at: number } | null = null

function errorHandler(
  error: apiClientErrorType,
  notify: AddNotificationType,
  router: Router
): void {
  const status = error.response?.status
  const errorResponse = error.response?.data as ErrorResponseType | undefined

  // error.message for ERR_NETWORK is too variable to assert against
  // each browser's message is too different to be reliable.
  // Asserting against error.code (from Axios) is more reliable.
  const message =
    errorResponse?.detail ??
    (error.code === 'ERR_NETWORK'
      ? GENERIC_NETWORK_ERROR_MESSAGE
      : status !== undefined && status >= 500
        ? GENERIC_SERVER_ERROR_MESSAGE
        : error.message)

  if (error.response?.status === 401) {
    router.push({ name: 'SettingsSignOut' })
  }
  if (
    ['ERR_NETWORK', 'ERR_BAD_REQUEST', 'ERR_BAD_RESPONSE'].includes(
      error.code || ''
    )
  ) {
    const now = Date.now()
    const isDuplicate =
      lastErrorNotify &&
      lastErrorNotify.message === message &&
      now - lastErrorNotify.at < ERROR_NOTIFY_DEBOUNCE_MS
    if (!isDuplicate) {
      lastErrorNotify = { message, at: now }
      notify({ type: 'error', message })
    }
  }
  if (import.meta.env.VITE_DEV_LOGGING === 'true') {
    console.error('Error: ', error)
  }
}

export { errorHandler }
